import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { settingsService, SiteSettings } from '../services/settings-service'

export function useSettings() {
    const queryClient = useQueryClient()

    // Query to fetch all settings
    const settingsQuery = useQuery({
        queryKey: ['settings'],
        queryFn: settingsService.getSettings,
        staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    })

    // Mutation to bulk-update settings safely
    const updateSettingsMutation = useMutation({
        mutationFn: settingsService.updateSettingsBulk,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['settings'] })
            toast.success('Ayarlar başarıyla kaydedildi')
        },
        onError: (err: any) => {
            const message = err.response?.data?.message || 'Ayarlar kaydedilirken bir hata oluştu'
            toast.error(message)
        }
    })

    // Mutation to initialize defaults manually if table is empty
    const initializeSettingsMutation = useMutation({
        mutationFn: settingsService.initializeSettings,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['settings'] })
            toast.success('Varsayılan ayarlar yüklendi')
        }
    })

    return {
        settings: settingsQuery.data as SiteSettings,
        isLoading: settingsQuery.isLoading,
        error: settingsQuery.error,
        updateSettings: updateSettingsMutation.mutateAsync,
        isUpdating: updateSettingsMutation.isPending,
        initializeSettings: initializeSettingsMutation.mutateAsync,
        isInitializing: initializeSettingsMutation.isPending
    }
}
